import { z } from "zod/v4";
import { common } from "../common";

/**
 * Schema for multi-language composition setup.
 * This is embedded in message variations to track locales and translations.
 *
 * @see Braze::Communication::MultiLanguageSupport::CompositionSetup
 */
export const multiLanguageCompositionSetupSchema = z.object({
  locale_ids: z.array(common.objectId),
  translation_in_use_ids: z.array(common.objectId),
});

/**
 * POST variant. The first locale selection on a message that has no setup yet
 * (LocaleSelector#commitSelection spreads an empty setup and sets only `locale_ids`)
 * posts the object without `translation_in_use_ids`. The server defaults the missing
 * key to [] (HasTranslations#update_multi_language_composition_setup_from_hash).
 * GET always returns both arrays (CompositionSetup#as_json).
 */
export const multiLanguageCompositionSetupPostSchema = z.object({
  ...multiLanguageCompositionSetupSchema.shape,
  translation_in_use_ids: z.array(common.objectId).optional(),
});
